import { css } from '@emotion/react';
var Fonts;
(function (Fonts) {
    // TODO: Unica77 Polestar TT - adjust when becomes the default font #breaking-change
    Fonts["polestarUnicaName"] = "Polestar Unica";
    Fonts["polestarUnica"] = "Polestar Unica,Helvetica Neue,Helvetica,Arial,sans-serif";
    /**
     * A different font-family for RTL languages.
     */
    Fonts["polestarUnicaRTL"] = "Polestar Unica, system-ui, -apple-system, sans-serif";
    Fonts["polestarIconsName"] = "Polestar Icons";
    Fonts["polestarIcons"] = "Polestar Icons";
})(Fonts || (Fonts = {}));
export default Fonts;
/**
 * @internal
 */
export const newFontOverride = (style) => {
    return css `
    [data-font=''] & {
      ${style};
    }
  `;
};
